import type { PartnerAddressResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { AddressInfoForm } from "../Components/Form/AddressInfoForm";

const addressInfoResources = Resources.base.partner.detail.addressInfo;

type PartnerAddressFormWidgetProps = {
	partnerId: number;
	data?: PartnerAddressResponseDto | null;
};

export function PartnerAddressFormWidget({
	partnerId,
	data,
}: PartnerAddressFormWidgetProps) {
	const { t } = useResource();
	return (
		<BaseCard title={t(addressInfoResources.title)}>
			<AddressInfoForm partnerId={partnerId} partnerAddressData={data} />
		</BaseCard>
	);
}
